import { render, staticRenderFns } from "./adult_surveillance.vue?vue&type=template&id=da8321d6&"
import script from "./adult_surveillance.vue?vue&type=script&lang=js&"
export * from "./adult_surveillance.vue?vue&type=script&lang=js&"
import style0 from "./adult_surveillance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports